import axios from 'axios';
import { getAuthToken } from 'utils/auth';
import { API_URL } from '../constants/http.constants';
import { refreshTokens } from './token';

const HTTP_CLIENT_TIMEOUT = 6000;

const errorHandlerInterceptor = (err) => Promise.reject(err);
const responseHandlerInterceptor = (response) => response.data;
const tokenInterceptor = async (config) => {
  const token = getAuthToken();
  config.headers['Content-Type'] = 'application/json';
  config.headers.Authorization = `Bearer ${token}`;

  return config;
};

const client = axios.create({
  baseURL: API_URL,
  timeout: HTTP_CLIENT_TIMEOUT,
});

// Access tokens live 15 minutes. A 401 is the expected outcome of an idle tab,
// not a dead end: refresh once and replay the request that hit the wall.
const unauthorizedHandlerInterceptor = async (err) => {
  const { config, response } = err;

  if (
    !response ||
    response.status !== 401 ||
    !config ||
    config.retriedAfterRefresh
  ) {
    return Promise.reject(err);
  }

  config.retriedAfterRefresh = true;

  try {
    await refreshTokens();
  } catch (refreshErr) {
    // refreshTokens() already logged out if the session was unrecoverable.
    return Promise.reject(err);
  }

  // The request interceptor re-reads storage, so the replay carries the new token.
  return client(config);
};

client.interceptors.response.use(
  responseHandlerInterceptor,
  unauthorizedHandlerInterceptor
);

client.interceptors.request.use(tokenInterceptor, errorHandlerInterceptor);

export default client;
